<template>
  <div class="headBar flex_g vertical between">
    <div class="logoView flex_g vertical">
      <img src="@/assets/images/logo_head.png" alt="">
    </div>
    <div class="menuView flex_g vertical">
      <div class="menuItem" v-for="(item, index) of menuList" :key="index" @click.stop="changePage(item)">
        <p class="menuName" :style="pageUrl == item.menuUrl ? 'color:#0548b8' : ''">{{ item.menuName }}</p>
        <p class="menuLine" v-if="pageUrl == item.menuUrl"></p>
        <div class="menuChildView" v-if="item.menuChild.length > 0">
          <div class="menuChildItem" @click.stop="changePage(s_item)"
            :class="pageUrl == s_item.menuUrl ? 'childSelect' : ''" v-for="(s_item, s_index) of item.menuChild"
            :key="s_index">
            <div>{{ s_item.menuName }}</div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
const MenuUrlType = {
  NO_ACTION: 0,
  PUSHES_TO_ROUTER: 1,
  OPENS_AT_NEW_WINDOW: 2
};

export default {
  components: {},
  props: {
    pageUrl: String,
    isChangeRoute: Boolean,
  },
  data() {
    return {
      isLogin: false,
      userInfo: {},
      setModal: false,
      menuList: [
        {
          menuName: "首页",
          menuUrl: "/index",
          menuUrlType: MenuUrlType.PUSHES_TO_ROUTER,
          menuChild: [],
        },
        {
          menuName: "数据集",
          // menuUrl: "",
          menuUrl: "/dataSet",
          menuUrlType: MenuUrlType.NO_ACTION,
          menuChild: [
            {
              menuName: "公开数据集",
              menuUrl: "/dataSet",
              menuUrlType: MenuUrlType.PUSHES_TO_ROUTER,
            },
          ],
        },
        // {
        //   menuName: "推理机",
        //   menuUrl: "",
        //   menuUrlType: MenuUrlType.OPENS_AT_NEW_WINDOW,
        //   menuChild: []
        // },
        {
          menuName: "开源项目",
          // menuUrl: "",
          menuUrlType: MenuUrlType.NO_ACTION,
          menuChild: [
              {
                  menuName: "StarryGL",
                  menuUrl: "/starryGl/home",
                  menuUrlType: MenuUrlType.PUSHES_TO_ROUTER,
              },
              {
                  menuName: "OpenGSL",
                  menuUrl: "https://github.com/OpenGSL/OpenGSL",
                  menuUrlType: MenuUrlType.OPENS_AT_NEW_WINDOW,
              },
              {
                  menuName: "时序图模型",
                  menuUrl: "https://github.com/starry-graph/FanXingFund-TemporalGraph",
                  menuUrlType: MenuUrlType.OPENS_AT_NEW_WINDOW,
              },
          ],
        },

        {
          menuName: "演示",
          menuUrl: "/demonstration",
          menuUrlType: MenuUrlType.PUSHES_TO_ROUTER,
          menuChild: [],
        },
        // {
        //   menuName: "文档",
        //   menuUrl: "/document",
        //   menuUrlType: MenuUrlType.PUSHES_TO_ROUTER,
        //   menuChild: [],
        // },
        {
          menuName: "关于",
          menuUrl: "/about",
          menuUrlType: MenuUrlType.NO_ACTION,
          menuChild: [
            {
              menuName: "最新动态",
              menuUrl: "/about/latestNews",
              menuUrlType: MenuUrlType.PUSHES_TO_ROUTER
            },
            {
              menuName: "关于我们",
              menuUrl: "/about/aboutUs",
              menuUrlType: MenuUrlType.PUSHES_TO_ROUTER,
            },
            {
              menuName: "项目成果",
              menuUrl: "/about/projectResult",
              menuUrlType: MenuUrlType.PUSHES_TO_ROUTER,
            },
          ],
        },
      ],
      picUrl: this.$store.state.picUrl,
    };
  },
  watch: {
    isChangeRoute() {

    },
  },
  computed: {},
  created() {
    console.log("head");
  },
  mounted() {

  },
  methods: {
    getPath() { },
    changePage(item) {
      if (item.menuUrlType == MenuUrlType.PUSHES_TO_ROUTER) {
        this.$router.push({
          path: item.menuUrl,
        });
      } else if (item.menuUrlType == MenuUrlType.OPENS_AT_NEW_WINDOW) {
        window.open(item.menuUrl, "_blank");
      }
    },
    openSetModal() {
      this.setModal = !this.setModal;
    },
    editInfo() {
      this.$router.push({
        path: "/",
      });
    },
  },
  created() { },
};
</script>
<style lang="scss" scoped>
.headBar {
  height: 5.36rem;
  background: #ffffff;
  box-shadow: 0rem 0rem 0.71rem 0.14rem rgba(206, 206, 206, 0.29);
  padding: 0 3.5rem;
  position: relative;
  z-index: 1000;

  .logoView {
    img {
      width: 10rem;
    }
  }

  .menuView {
    padding: 0 6rem;
    height: 100%;
    flex: 1;
    text-align: left;

    .menuItem {
      position: relative;
      height: 100%;
      margin: 0 2rem;
      line-height: 5.36rem;
      width: 4rem;

      .menuName {
        font-size: 1rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #6782a4;
        text-align: center;
      }

      .menuLine {
        position: absolute;
        left: 50%;
        bottom: 0;
        width: 2rem;
        transform: translate(-50%, -50%);
        height: 0.21rem;
        background: #0548b8;
        box-shadow: 0rem 0.07rem 0.29rem 0rem #9fd4f8;
        border-radius: 0.11rem;
      }

      .menuChildView {
        display: none;
        position: absolute;
        top: 5rem;
        left: -1rem;
        width: 13rem;
        background: #ffffff;
        box-shadow: 0rem 0.14rem 0.79rem -0.07rem rgba(0, 99, 206, 0.49);
        padding: 0.5rem 0;
        border-radius: 0.6rem;
        z-index: 510;

        .menuChildItem {
          padding: 1.2rem 2.3rem;

          div {
            font-size: 1rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #6782a4;
            line-height: 1.3rem;
          }
        }

        .menuChildItem:hover {
          background: #f0f6ff;

          div {
            color: #0548b8;
          }
        }
      }

      .menuChildView:after {
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        top: -0.8rem;
        left: 2rem;
        border-bottom: 0.8rem solid #fff;
        border-left: 0.6rem solid transparent;
        border-right: 0.6rem solid transparent;
        z-index: 1;
      }
    }

    .menuItem:hover {
      cursor: default;

      .menuName {
        color: #0548b8;
        animation: navShake 0.5s ease;
      }

      @keyframes navShake {
        0% {
          transform: translateY(0px);
        }

        50% {
          transform: translateY(-5px);
        }

        100% {
          transform: translateY(0px);
        }
      }

      .menuChildView {
        display: block;
      }
    }
  }

  .loginView {
    height: 100%;

    .waitLogin {
      height: 100%;

      p:nth-child(1) {
        font-size: 1rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #6782a4;
        line-height: 1.43rem;
        margin-right: 2rem;
      }

      p:nth-child(2) {
        width: 8rem;
        height: 2.74rem;
        background: #0548b8;
        border-radius: 0.29rem;
        font-size: 1rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 2.84rem;
        text-align: center;
        box-shadow: 0rem 0.14rem 0.79rem -0.07rem rgba(0, 99, 206, 0.49);
        cursor: default;
      }
    }

    .islogin {
      height: 100%;
      position: relative;

      .userImgView {
        margin-right: 0.7rem;

        img {
          width: 2.2rem;
        }
      }

      .userName {
        font-size: 1rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
        margin-right: 2.3rem;
      }

      .loginOut {
        img {
          width: 1.2rem;
          margin-right: 0.3rem;
        }

        p {
          font-size: 1rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #6782a4;
        }
      }

      .setModal {
        position: absolute;
        top: 4.5rem;
        left: 1.5rem;
        background: #fff;
        padding: 0.8rem 2.5rem;
        border-radius: 0.5rem;
        box-shadow: 0rem 0rem 0.71rem 0.14rem rgba(206, 206, 206, 0.29);

        .setView {
          p {
            color: #666;
            font-size: 1rem;
          }
        }
      }

      .setModal:after {
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        top: -0.8rem;
        left: 2.5rem;
        border-bottom: 0.8rem solid #fff;
        border-left: 0.6rem solid transparent;
        border-right: 0.6rem solid transparent;
        z-index: 1;
      }
    }
  }
}
</style>